"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextArea_1 = require("./TextArea");
exports.default = TextArea_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/TextArea/index.js
// module id = 1278
// module chunks = 8